module.exports = __webpack_public_path__ + "static/media/dashboardpage-browsefreelancerscard-avatar-2.48a23fe1.webp";